import { render, staticRenderFns } from "./SpecialCustomerList.vue?vue&type=template&id=c5223ce2&scoped=true"
import script from "./SpecialCustomerList.vue?vue&type=script&lang=js"
export * from "./SpecialCustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5223ce2",
  null
  
)

export default component.exports